import React, { useEffect } from 'react';
import './Terms.css';

const TermsandPolicies = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top of the page
  }, []);

  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>

      <section>
        <h2>1. General Terms</h2>
        <p>
          By availing of our services, you agree to comply with these terms and conditions. These terms are designed to govern the use of our services and ensure a smooth business relationship.
        </p>
      </section>

      <section>
        <h2>2. Service Scope</h2>
        <p>
          We offer a variety of services related to registration, compliance, tax filing, web solutions, and business support. The scope of each service will be defined in the service agreement at the time of engagement.
        </p>
        <p>
          Any additional work outside the agreed scope will be charged separately and subject to approval.
        </p>
      </section>

      <section>
        <h2>3. Payment Terms</h2>
        <p>
          Payments for all services must be made upfront or as per the payment schedule agreed upon. Late payments may attract penalties or interest as per applicable laws.
        </p>
        <p>
          Prices are subject to change based on market conditions, regulatory requirements, or other factors. Updated pricing will be communicated before engagement.
        </p>
      </section>

      <section>
        <h2>4. Compliance and Responsibilities</h2>
        <p>
          Clients are responsible for providing accurate and complete information required to process any service. Inaccurate or incomplete information may result in delays or additional charges.
        </p>
        <p>
          We reserve the right to decline or terminate services if the provided information violates any legal or regulatory standards.
        </p>
      </section>

      <section>
        <h2>5. Refunds and Cancellations</h2>
        <p>
          Refunds will not be provided for services already initiated or completed. Cancellations must be requested before the commencement of the service. Partial refunds may be issued for cancellations at our discretion.
        </p>
      </section>

      <section>
        <h2>6. Confidentiality</h2>
        <p>
          We are committed to protecting your personal and business information. All data shared with us will be treated as confidential and used solely for the purpose of providing services.
        </p>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <p>
          We shall not be held liable for any indirect, incidental, or consequential damages arising from the use of our services. Our total liability is limited to the amount paid for the specific service in question.
        </p>
      </section>

      <section>
        <h2>8. Regulatory Compliance</h2>
        <p>
          All services are provided in accordance with applicable laws and regulations. Any changes in the law that impact the scope or pricing of the services will be communicated promptly.
        </p>
      </section>

      <section>
        <h2>9. Amendments to Terms</h2>
        <p>
          We reserve the right to update or modify these terms and conditions at any time. Clients will be notified of any major changes in advance.
        </p>
      </section>

      <section>
        <h2>10. Governing Law</h2>
        <p>
          These terms and conditions are governed by and construed in accordance with the laws of India. Any disputes will be resolved in the jurisdiction of the courts in your operating city.
        </p>
      </section>
    </div>
  );
};

export default TermsandPolicies;
